"use client";

import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import { useSession } from "next-auth/react";
import { RightSidebarTabs } from "./right-sidebar-tabs";
import { useRightTabs } from "@/contexts/right-tabs-context";

export default function RightSidebarTabsContainer() {
  const router = useRouter();
  const pathname = usePathname();
  const { data: session } = useSession();
  const {
    history,
    liked,
    activeListingId,
    setActiveListing,
    clearHistory,
    clearLiked,
    setIsExpanded,
    isExpanded,
  } = useRightTabs();

  // Navigate to search page with modal when item is selected
  useEffect(() => {
    if (activeListingId) {
      // Navigate to search page with modal parameter
      router.push(`/search?modal=${activeListingId}`);
      // Clear active after navigation
      setActiveListing(null);
    }
  }, [activeListingId, router, setActiveListing]);

  // Hide right sidebar on admin pages (admin has its own layout)
  const isAdminPage = pathname?.startsWith("/admin");
  if (isAdminPage) {
    return null;
  }

  const isAdmin = session?.user?.role === "ADMIN";

  return (
    <RightSidebarTabs
      history={history}
      liked={liked}
      activeListingId={activeListingId}
      onItemSelect={(id) => setActiveListing(id)}
      onClearHistory={clearHistory}
      onClearLiked={clearLiked}
      onToggle={setIsExpanded}
      isExpanded={isExpanded}
      isAdmin={isAdmin}
    />
  );
}
